import { Box, CircularProgress } from '@mui/material';

export const Splash = () => (
  <Box
    sx={{
      position: 'fixed',
      inset: 0,
      backgroundColor: '#00305e',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <CircularProgress sx={{ color: 'white' }} />
  </Box>
);
